import React, { useState } from "react";
import * as XLSX from "xlsx";
import { Button } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";
import { openNotificationWithIcon } from "../utils";

interface ExportToExcelProps {
  data: Record<string, any>[];
  fileName?: string;
  disabled?: boolean;
  sheetName?: string;
}

const ExportToExcel: React.FC<ExportToExcelProps> = ({
  data,
  fileName = "export.xlsx",
  disabled = false,
  sheetName = "Sheet1",
}) => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
      XLSX.writeFile(workbook, fileName);
    } catch (err) {
      openNotificationWithIcon("error", "Failed to export data", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      icon={<FileExcelOutlined />}
      onClick={handleExport}
      disabled={disabled}
      loading={loading}
      style={{ height: 40 }}
      className="export-button primary"
    >
      Export to Excel
    </Button>
  );
};

export default ExportToExcel;
